

import { CommandChangePassword } from "./commands/CmdChangePassword";
import { CommandChangePasswordExternal } from "./commands/CmdChangePasswordExternal";
import { CommandaRequestChangePassword } from "./commands/CmdRequestChangePassword";

export class ChangePasswordService {
    async requestChangePassword(email: string) {
        const cmd = new CommandaRequestChangePassword();
        const results = await cmd.run(email);
        return results;
    }

    async changePassword(password: string) {
        const cmd = new CommandChangePassword();
        const results = await cmd.run(password);
        return results;
    }
    async changePasswordExternal(token: string, userId: string | number, password: string) {
        const cmd = new CommandChangePasswordExternal();
        const results = await cmd.run(token, userId, password);
        return results;
    }
}